import { Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { ArrowRightCircleFill } from 'react-bootstrap-icons'

import { CustomPriceInput } from '../../../../../components/CustomPriceInput'

import {
  ContainerComponent,
  ContentComponent,
  FooterComponent,
  NextButton,
} from '../../styles'
import { CustomDecimalInput } from '../../../../CustomDecimalInput'

export function Precos({ isVisible, onNext, product, handleChange }) {
  if (!isVisible) {
    return null
  }

  return (
    <ContainerComponent>
      <div>
        <ContentComponent>
          <h4>Preços</h4>

          <Row className="mb-3">
            <Col>
              <Form.Label>* Preço Custo R$</Form.Label>
              {localStorage.admin === 'SIM' ? (
                <CustomPriceInput
                  name="PRECOCUSTO"
                  value={product.PRECOCUSTO}
                  onChange={(e) => handleChange(e, 'precos')}
                />
              ) : (
                <div
                  style={{
                    color: '#dc2626',
                    fontSize: '14px',
                    marginTop: '8px',
                  }}
                >
                  Você não tem permissão para editar este campo
                </div>
              )}
            </Col>

            <Col>
              <Form.Label>* Preço Venda R$</Form.Label>
              <CustomPriceInput
                name="PRECOVENDA"
                value={product.PRECOVENDA}
                onChange={(e) => handleChange(e, 'precos')}
              />
            </Col>

            <Col>
              <Form.Label>Preço Atacado R$</Form.Label>
              <CustomPriceInput
                name="PRECOATACADO"
                value={product.PRECOATACADO}
                onChange={(e) => handleChange(e, 'precos')}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>Preço Promocial Varejo R$</Form.Label>

              <CustomPriceInput
                name="PRECOVAREJO_P"
                value={product.PRECOVAREJO_P}
                onChange={(e) => handleChange(e, 'precos')}
              />
            </Col>

            <Col>
              <Form.Label>Preço Promocial Atacado R$</Form.Label>
              <CustomPriceInput
                name="PRECOATACADO_P"
                value={product.PRECOATACADO_P}
                onChange={(e) => handleChange(e, 'precos')}
              />
            </Col>

            <Col>
              <Form.Label>Comissão Sobre Produto %</Form.Label>
              <CustomDecimalInput
                name="COMISSAO_SOBRE_PRODUTO"
                value={product.COMISSAO_SOBRE_PRODUTO}
                onChange={(e) => handleChange(e, 'precos')}
              />
            </Col>
          </Row>
        </ContentComponent>

        <FooterComponent>
          <OverlayTrigger overlay={<Tooltip>Avançar</Tooltip>}>
            <NextButton onClick={onNext}>
              <ArrowRightCircleFill
                size={15}
                color="white"
              />
            </NextButton>
          </OverlayTrigger>
        </FooterComponent>
      </div>
    </ContainerComponent>
  )
}
